import Mastercard from "./Mastercard";
import Visa from "./Visa";

export default { Mastercard, Visa };
